/**
* @ngdoc service
* @name common.service:CsBsService
* @description
* Coming Soon/Back Soon service.
*/
(function() {
  'use strict';

  angular
  .module('itxApp.common')
  .service('CsBsService', CsBsService);

  CsBsService.$inject = ['$q'];

  function CsBsService ($q) {

    var service =  {
      isEnabled: isEnabled,
      subscribeCsBs:subscribeCsBs,
      unSubscribeCsBs: unSubscribeCsBs
    };

    return service;

    /**
    * @ngdoc method
    * @name isEnabled
    * @methodOf 
    * @description
    * Check if the service is enabled through xconfiguration variable.
    */
    function isEnabled(){
      return $q(
        function(resolve, reject){
          joyr.rest.xRestGetXConfiguration('ENABLE_XNOTIFICACION_STOCK_SUBSCRIBER')
          .done(function (value) {
            resolve(value == 1);
          })
          .Catch(function(){
            reject();
          });
        }
      );
    }

    /**
    * @ngdoc method
    * @name subscribeCsBs
    * @methodOf common.newsletter.service:ItxNewsletterSvc
    * @description
    * Subscribe to the Coming soon back soon service.
    */
    function subscribeCsBs(email){

      var deferred = $q.defer();

      var action = {
          action: 'user:stockNotificationRequest',
          params: {
              storeId: inditex.iStoreId,
              languageId: inditex.iLangId
          },
          data: {
              'email': email
          }
      };

      joyr.rest.xRestExecute([action])
      .done(function(){
          deferred.resolve();
      })
      .Catch(function(err){
          deferred.reject(err);
      });

      return deferred.promise;
    }

    /**
    * @ngdoc method
    * @name unSubscribeCsBs
    * @methodOf ItxNewsletterSvc
    * @description
    * Unsubscribe from Coming soon/Back soon service.
    * @param {string} email user email.
    */
    function unSubscribeCsBs(email){
      var deferred = $q.defer();

      var action = {
          action: 'user:stockNotificationDelete',
          params: {
              storeId: inditex.iStoreId,
              languageId: inditex.iLangId,
              email: email,
              hashValue: undefined
          }
      };
      joyr.rest.xRestExecute([action])
      .done(function(){
          deferred.resolve();
      })
      .Catch(function(err){
          deferred.reject(err);
      });
          
      return deferred.promise;
    }

  }

})();